import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import useClosable from '../hooks/useClosable';
import useMarkInactiveValidationSchema from '../hooks/useMarkInactiveValidationSchema';
import { ClosableOrder } from '../store/ClosableStore';
import commonStyles from "./Common.module.css";
import StringInput from './inputs/StringInput';
import Modal from "./Modal";

function MarkInactiveModal({ entityName, onCancel, onMarkInactive }: IMarkInactiveModalProps) {
    const validationSchema = useMarkInactiveValidationSchema();

    const formik = useFormik<IInactiveReasonState>({
        initialValues: InactiveReasonState.empty(),
        validationSchema: toFormikValidationSchema(validationSchema),
        onSubmit: (values) => {
            onMarkInactive(values.reason!);
        },
    });

    useClosable(ClosableOrder.High, onCancel);

    return (
        <Modal header={`Mark ${entityName} inactive?`} onClose={onCancel}>
            <StringInput formik={formik} label="REASON" name="reason" autoFocus />
            <div className={[commonStyles.modalControls, commonStyles.controlGroup].join(" ")}>
                <button className={commonStyles.secondaryButton} onClick={onCancel}>Cancel</button>
                <button type="submit" className={commonStyles.primaryButton} onClick={() => formik.handleSubmit()}>Mark Inactive</button>
            </div>
        </Modal>
    );
}

interface IMarkInactiveModalProps {
    entityName: string;
    onCancel: () => void;
    onMarkInactive: (reason: string) => void;
}

export default observer(MarkInactiveModal);

interface IInactiveReasonState {
    reason: string | null;
}

class InactiveReasonState implements IInactiveReasonState {
    reason: string | null = null;

    static empty() {
        return new InactiveReasonState();
    }
}